import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

// assets
import successImage from 'assets/images/success-image.svg'
import { IFilteredGymTrainerList } from 'types/GymType'
import DateUtil from 'utils/DateUtil'
import useGymSalonReservationModal from '../../hooks/use-gym-salon-reservation-modal'
import NotificationDialog from 'components/ui/NotificationDialog'
import GymTrainerCard from './GymTrainerCard'
import ReservationModalWrapper from './reservation-scheduler/ReservationModal'

interface ComponentProps {
  filteredDate: Date | undefined
  renderList: IFilteredGymTrainerList[] | []
}

const defaultDate = DateUtil.getStartOfDay(new Date())

export default function GymTrainerCardContainer({ filteredDate, renderList }: ComponentProps) {
  const history = useHistory()
  const { t } = useTranslation()
  const _filteredDate = filteredDate || defaultDate

  /* Reservation Modal (Open - Close, Selected Gym Trainer). | Custom Hook */
  const {
    openModal,
    closeModal,
    modal: isOpen,
    selectedSalon: selectedTrainer,
    setSelectedSalon: setSelectedTrainer,
    notification,
    setNotification,
  } = useGymSalonReservationModal<IFilteredGymTrainerList>()

  return (
    <>
      {renderList?.map((datum) => (
        <GymTrainerCard key={datum.id} openModal={openModal} trainer={datum} />
      ))}

      {/* Gym Trainer Reservation Scheduler Modal */}
      {!!selectedTrainer ? (
        <ReservationModalWrapper
          trainers={renderList}
          open={isOpen}
          openModal={openModal}
          closeModal={closeModal}
          showNotification={() => setNotification(true)}
          selectedTrainer={selectedTrainer}
          setSelectedTrainer={setSelectedTrainer}
          filterDate={_filteredDate}
        />
      ) : null}

      <NotificationDialog
        display={notification}
        imgSrc={successImage}
        goHomeButton={true}
        title={t('gym-res-modal.notification-title')}
        content={t('gym-res-modal.notification-text')}
        firstButtonLabel={t('buttons.go-to-calendar')}
        onHide={() => setNotification(false)}
        onSubmit={() => history.push('/calendar')}
        selectedType={null}
        setSelectedType={undefined}
        types={[]}
      />
    </>
  )
}
